import { IFiltersPaths } from '@/types';

export const FILTERS_PATHS: IFiltersPaths = {
  GET_FILTERS: { _: 'filters/', BY_ID: type => `filters/${type}/` },
  GET_COMPANIES: { _: 'filters/companies/' },
  GET_COHORTS: { _: 'cohorts/filters/' },
};
